import ButtonGroup from '@mui/material/ButtonGroup';
import CustomButton from 'src/core/ui/CustomButton';
import SaveIcon from '@mui/icons-material/Save';
import RestorePageIcon from '@mui/icons-material/RestorePage';
import type { tableSettingsProps } from 'src/core/tables/useTableSettings';
import { AdditionalTableEdits, commitPendingTableEdits, discardTableEdits, getTableSubmitRows, hasTableChanges, } from 'src/core/tables/helpers/tableEditActions';

const SaveDiscardButtons = ({ tableSettings, submit, additionalEdits, }: SaveDiscardButtonsProps) => {
  const hasChanges = hasTableChanges(tableSettings, additionalEdits);
  const save = async () => {
    await commitPendingTableEdits(tableSettings, additionalEdits);
    const submitRows = getTableSubmitRows(tableSettings, additionalEdits);
    submit(submitRows);
  };
  const discard = () => {
    discardTableEdits(tableSettings, additionalEdits);
  };

  return (
    <ButtonGroup>
      <CustomButton title="Discard" color="error" disabled={!hasChanges} icon={<RestorePageIcon />} onClick={discard} />
      <CustomButton title="Save" disabled={!hasChanges} icon={<SaveIcon />} onClick={save} />
    </ButtonGroup>
  );
};

export default SaveDiscardButtons;

type SaveDiscardButtonsProps = {
  tableSettings: tableSettingsProps;
  submit: (v: any, options?: any) => void;
  additionalEdits?: AdditionalTableEdits | AdditionalTableEdits[];
};
